<div class="container h-full flex flex-col gap-4 mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex flex-wrap items-center gap-2 min-h-10">
    <h2 class="text-2xl font-medium">Notificaties</h2>
  </div>

  <div>
    <mat-chip-listbox
      hideSingleSelectionIndicator
      class="inline-flex! py-1 px-2 bg-white rounded-full [--mdc-chip-outline-color:transparent] [--mdc-chip-container-shape-radius:24px] [--mdc-chip-label-text-color:var(--color-gray-500)] [--mdc-chip-elevated-selected-container-color:var(--color-secondary-200)]  [--mdc-chip-selected-label-text-color:var(--color-secondary-800)]"
      (change)="handleTypeChange($event)"
    >
      <mat-chip-option value="" selected [selectable]="selectedFilterType() !== ''"
        >Alle</mat-chip-option
      >

      @for (option of typeOptions; track option.value) {
        <mat-chip-option
          [value]="option.value"
          [selectable]="selectedFilterType() !== option.value"
          >{{ option.label }}</mat-chip-option
        >
      }
    </mat-chip-listbox>
  </div>

  <app-data-table-container class="rounded-lg">
    <table
      mat-table
      matSort
      matSortDirection="desc"
      matSortActive="created_at"
      matSortDisableClear
      [matSortDisabled]="hasNoData()"
      (matSortChange)="handleSortChange($event)"
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="type">
        <th mat-header-cell mat-sort-header="type" *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element">
          {{ element.type | mapFrom: typeLabelMapping }}
        </td>
      </ng-container>

      <ng-container matColumnDef="recipients" sticky>
        <th mat-header-cell mat-sort-header="recipients" *matHeaderCellDef>Ontvanger</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="w-min max-w-60 truncate block"
            [matTooltip]="element.recipients.join(', ')"
            matTooltipPosition="after"
            >{{ element.recipients.join(', ') }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell mat-sort-header="status" *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="text-xs font-medium px-3 py-2 rounded-full"
            [ngClass]="{
              'bg-yellow-100 text-yellow-950': element.status === 'pending',
              'bg-blue-100 text-blue-950': element.status === 'sending',
              'bg-green-100 text-green-950': element.status === 'sent',
              'bg-red-100 text-red-950': element.status === 'failed',
              'bg-gray-100 text-gray-950': !isKnownStatus(element.status),
            }"
          >
            {{ (element.status | mapFrom: statusMapping) || element.status }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="attemptCount">
        <th mat-header-cell mat-sort-header="attempt_count" *matHeaderCellDef>
          Verzendpogingen
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            class="underline decoration-dotted cursor-help"
            [matTooltip]="attemptTooltip"
          >
            {{ formatAttemptCount(element.attemptCount) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell mat-sort-header="created_at" *matHeaderCellDef>
          Verstuurd op
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:!bg-gray-100 whitespace-nowrap"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns.length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <mat-paginator
      class="border-t border-(--mat-table-row-item-outline-color)"
      (page)="handlePageChange($event)"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[25, 50, 100]"
    ></mat-paginator>
  </app-data-table-container>
</div>
